import { Tooltip } from '../../feedback/Tooltip';
import { AdvertisingPromoText } from '../AdvertisingPromoText/AdvertisingPromoText';
import { AdvertisingPromoTooltipProps } from './types';

export const AdvertisingPromoTooltip: React.FC<AdvertisingPromoTooltipProps> = ({
    text,
    ...other
}) => (
    <Tooltip
        options={{ placement: 'top' }}
        variant="onboarding"
        disableHoverEvents
        autoOpen
        {...other}
    >
        <AdvertisingPromoText />
    </Tooltip>
);
